import { IDLE, LOADING, SUCCESS } from '../../../../enums/states';
import { createReducer } from '../../utils/reducer';

import { CLOSED_TRANSACTIONS_FETCH, CLOSED_TRANSACTIONS_SUCCESS } from '../../../actions/dashboard/closedTransactions';

const initialState = {
  data: null,
  error: null,
  state: IDLE,
};

const handlers = {
  [CLOSED_TRANSACTIONS_FETCH]: (state) => {
    return {
      ...state,
      state: LOADING,
    };
  },
  [CLOSED_TRANSACTIONS_SUCCESS]: (state, action) => {
    return {
      ...state,
      state: SUCCESS,
      data: action.payload,
    };
  },
};

export default createReducer(initialState, handlers);
